import moment from 'moment';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import SohoFrameworkTestKeys from '../../Utils/SohoFrameworkTestKeys';

import { USAGE_TYPES, USAGE_DURATION_TYPES } from './Enums';

const getPlaceholdersBasedOnUsageType = ({ usageType, amount, units, totalAmount, totalUnits }) => {
  const valuePlaceholders = [];
  valuePlaceholders.push(usageType === USAGE_TYPES.DATA ? `${amount}${units}` : `${amount}`);
  valuePlaceholders.push(getUsagePlaceholderBasedOnUsageType(usageType, totalAmount, totalUnits));
  return valuePlaceholders;
};

const getUsagePlaceholderBasedOnUsageType = (usageType, amount, units) => {
  if (usageType === USAGE_TYPES.SMS) {
    return `${amount}`;
  } else if (usageType === USAGE_TYPES.DATA) {
    return `${amount}${units}`;
  } else {
    return `${amount}${units}`;
  }
};

const getFormattedDate = ({ period, startDate, endDate }) => {
  const momentStartDate = moment(startDate, 'DD/MM/YYYY');
  const momentEndDate = endDate ? moment(endDate, 'DD/MM/YYYY') : null;

  switch (period) {
    case USAGE_DURATION_TYPES.DAY:
      return momentStartDate.format('dddd, D MMM');
    case USAGE_DURATION_TYPES.WEEK: {
      if (momentStartDate.month() === momentEndDate?.month()) {
        return `${momentStartDate.format('D')}-${momentEndDate?.format('D MMM')}`;
      } else {
        return `${momentStartDate.format('D MMM')} - ${momentEndDate?.format('D MMM')}`;
      }
    }
    case USAGE_DURATION_TYPES.MONTH: {
      if (momentStartDate.year() === momentEndDate?.year()) {
        return `${momentStartDate.format('D MMM')} - ${momentEndDate?.format('D MMM, YYYY')}`;
      } else {
        return `${momentStartDate.format('D MMM, YYYY')} - ${momentEndDate?.format('D MMM, YYYY')}`;
      }
    }
    default:
      return 'invalid date';
  }
};

function getUsageProperColor(usageType) {
  switch (usageType) {
    case USAGE_TYPES.DATA:
      return Colors.ocean;
    case USAGE_TYPES.SMS:
      return Colors.tangerine;
    case USAGE_TYPES.CALLS:
    default:
      return Colors.warmPurpleTwo;
  }
}

const getAddUsageButtonLabel = usageType => {
  switch (usageType) {
    case USAGE_TYPES.DATA:
      return 'soho_plans_plan_add_data_button_label';
    case USAGE_TYPES.CALLS:
      return 'soho_plans_plan_add_calls_button_label';
    case USAGE_TYPES.SMS:
      return 'soho_plans_plan_add_sms_button_label';
    default:
      return '';
  }
};

const getAddUsageButtonTestKey = usageType => {
  switch (usageType) {
    case USAGE_TYPES.DATA:
      return SohoFrameworkTestKeys.PlanAddDataBtn;
    case USAGE_TYPES.CALLS:
      return SohoFrameworkTestKeys.PlanAddCallBtn;
    case USAGE_TYPES.SMS:
      return SohoFrameworkTestKeys.PlanAddSMSBtn;
    default:
      return '';
  }
};

const getUserAddUsageButtonLabel = usageType => {
  switch (usageType) {
    case USAGE_TYPES.DATA:
      return 'soho_my_plans_request_usage_data_label';
    case USAGE_TYPES.CALLS:
      return 'soho_my_plans_request_usage_calls_label';
    case USAGE_TYPES.SMS:
      return 'soho_my_plans_request_usage_sms_label';
    default:
      return '';
  }
};

export {
  getPlaceholdersBasedOnUsageType,
  getUsagePlaceholderBasedOnUsageType,
  getFormattedDate,
  getUsageProperColor,
  getAddUsageButtonLabel,
  getAddUsageButtonTestKey,
  getUserAddUsageButtonLabel,
};
